import { AREAS, partsToText } from './areas';
import { SITE_ORIGIN } from './site';

function city(name, adminArea) {
  const place = { '@type': 'City', name };
  if (adminArea) {
    place.containedInPlace = { '@type': 'AdministrativeArea', name: adminArea };
  }
  return place;
}

function faqEntity(faqs) {
  return {
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: partsToText(faq.a),
      },
    })),
  };
}

export function areaJsonLd(area) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Service',
        name: area.h1,
        serviceType: 'Rubbish removal',
        description: area.description,
        url: `${SITE_ORIGIN}${area.path}`,
        areaServed: city(area.name, area.adminArea),
        provider: {
          '@type': 'LocalBusiness',
          name: 'The WasteGame',
          url: SITE_ORIGIN,
          email: 'info@thewastegame.co.uk',
          areaServed: city(area.name, area.adminArea),
        },
      },
      faqEntity(area.faqs),
    ],
  };
}

export function areasIndexJsonLd(page) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'LocalBusiness',
        name: 'The WasteGame',
        url: `${SITE_ORIGIN}${page.path}`,
        email: 'info@thewastegame.co.uk',
        description: page.description,
        areaServed: AREAS.map((area) => city(area.name, area.adminArea)),
      },
      {
        '@type': 'ItemList',
        name: page.h1,
        itemListElement: AREAS.map((area, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: area.h1,
          url: `${SITE_ORIGIN}${area.path}`,
        })),
      },
    ],
  };
}
